import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import tableExternalResources from './tableExternalResources';
import tableVodCatalog from './tableVodTemplateCatalog'

export default {
  title: 'General Settings',
  attributeName: 'sourceFilesFormGroup',
  fields: [
    {
      attributeName: 'name',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      placeholder: 'Video name',
      label: 'Name',
      helpText: 'Name to identify the job in the XMS.',
      errorText: '',
    },
    {
      attributeName: 'folder',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      placeholder: 'Folder name',
      label: 'Folder',
      helpText: 'Folder to be moved into the origins.',
      errorText: '',
    },
  ],
};
